<template>
  <div class="flex flex-col h-full">
    <div class="p-3">
      <div class="flex gap-2 items-center mb-2 py-2 border-b border-b-gray-200">
        <u-button
          to="/digitization-projects"
          variant="soft"
          icon="i-ri-arrow-left-line"
          color="charcoal"
          size="xs"
          title="Back to Digitization Projects"
        />
        <h3 class="font-serif text-xl flex-1">Projects</h3>
      </div>
    </div>

    <div class="flex-1 scrollbar-light overflow-y-auto -mr-[13px] firefox:pr-[13px] pr-[7px] scrollbar-gutter-stable pb-10" ref="listEl">
      <transition-group name="f-slide-fade">
        <core-contextual-loading-box v-if="pending" size="xs" key="loading" loading-text="Loading Projects" />
        <core-contextual-error-box v-else-if="error" size="xs" key="error" :action="refresh" />

        <core-list v-else :items="projects" :scroller-elem="listEl" :disable-approach-bottom="pending" container-class="grid" grid-gap-class="gap-2" item-class="min-w-0" :section-size="Infinity">
          <template #default="{ item: project }">
            <nuxt-link
              active-class="!bg-slate-200 is-active"
              class="group text-charcoal no-underline hover:bg-slate-100 py-2 px-1.5 mx-1 flex rounded whitespace-nowrap"
              :to="toDigitizationProject(project)"
              :data-project-id="project.id"
            >
              <div class="flex-1 flex min-w-0 gap-1">
                <digitization-avatar :project="project" size="sm" />

                <div class="flex flex-1 flex-col gap-1.5 text-sm leading-none break-long-string">

                  <div class="flex items-center justify-between leading-none">
                    <span class="font-semibold text-sm leading-none">{{project.name}}</span>
                    <span class="text-xs leading-none" v-if="project.orderDateText">{{project.orderDateText}}</span>
                  </div>

                  <digitization-status-secondary-text :project="project" />

                  <div class="flex items-center justify-between">
                    <digitization-status-badge :project="project" size="xs" />
                    <span class="text-xs text-charcoal-400" v-if="project.files_count">{{project.files_count}} Files</span>
                  </div>

                </div>
              </div>

            </nuxt-link>
          </template>
        </core-list>
      </transition-group>
    </div>
  </div>
</template>

<script setup>
  const listEl = ref();
  const digitizationStore = useDigitizationStore();
  const {projects, project} = storeToRefs(digitizationStore);
  const buildRoute = useBuildRoute();

  function toDigitizationProject(project) {
    return buildRoute.toDigitizationProject({boxId: project.id});
  }

  const {refresh, pending, error} = await useAsyncData(
    'digitizationProjects',
    async () => {
      await digitizationStore.getProjects();
      digitizationStore.setupTransferProjectCheck();
    },
    {server: false}
  );

  async function scrollToCurrentProject() {
    await nextTick();
    if (listEl.value) {
      const projectEl = listEl.value.querySelector(`[data-project-id="${project.value?.id}"]`);
      if (projectEl) {
        projectEl.scrollIntoView({behavior: 'instant', block: 'start'});
      }
    }
  }

  onMounted(async () => {
    await waitFor(500);
    await scrollToCurrentProject();
  });
</script>
